import ClipboardContainer from "../../../../../Components/Forms&Table/Forms/FormWidgets/Clipboard/ClipboardContainer";

const Clipboard = () => {
  return <ClipboardContainer />;
};

export default Clipboard;
